import {InfluenceMapIcon} from "@/components/icons/influence-map";
import {House, MessageCircle, Star, type LucideIcon} from "lucide-react";

export interface NavItem {
  title: string;
  url: string;
  icon: LucideIcon;
  messageKey: string;
}

export const navigation: NavItem[] = [
  {
    title: "Home",
    url: "/home",
    icon: House,
    messageKey: "nav_main",
  },
  {
    title: "Chat",
    url: "/chat",
    icon: MessageCircle,
    messageKey: "nav_chat",
  },
  {
    title: "Map of Influence",
    url: "/influence-map",
    icon: InfluenceMapIcon,
    messageKey: "nav_influence_map",
  },
  {
    title: "Favorites",
    url: "/favorites",
    icon: Star,
    messageKey: "nav_favorites",
  },
];
